import { useMemo } from 'react';

import { useLocation, matchPath } from 'react-router-dom';

export interface BreadcrumbRoute {
  path: string;
  breadcrumb: string | ((params: Record<string, string>) => string);
}

export const useBreadcrumbs = (routes: BreadcrumbRoute[]) => {
  const location = useLocation();

  return useMemo(() => {
    const segments =
      location.pathname === '/'
        ? ['/']
        : location.pathname.split('/').filter(Boolean);
    const breadcrumbs = [];

    let pathAccumulator = '';

    for (let i = 0; i < segments.length; i++) {
      pathAccumulator += `/${segments[i]}`;

      const routeMatch = routes.find((r) => matchPath(r.path, pathAccumulator));

      if (
        routeMatch &&
        segments.length === 1 &&
        segments.includes(routeMatch.path.replace('/', ''))
      ) {
        continue;
      }

      if (routeMatch) {
        const match = matchPath(routeMatch.path, pathAccumulator);
        const label =
          typeof routeMatch.breadcrumb === 'function'
            ? routeMatch.breadcrumb(
                Object.fromEntries(
                  Object.entries(match?.params || {}).filter(
                    ([_, v]) => v !== undefined
                  )
                ) as Record<string, string>
              )
            : routeMatch.breadcrumb;

        breadcrumbs.push({ label, href: pathAccumulator });
      }
    }

    return breadcrumbs;
  }, [location.pathname, routes]);
};
